import MobileSearchModal from "./MobileSearchModal";
import MoreToolsTriggerButton from "./MoreToolsTriggerButton";
import MoreToolsPopupMenu from "./MoreToolsPopupMenu";
import MoreToolsMobileDrawer from "./MoreToolsMobileDrawer";
import useMoreToolsDropdown from "./useMoreToolsDropdown";

/**
 * MoreToolsDropdown — Adaptive Navigation:
 * - On tablet / medium screens (640px - 1023px): Renders the compact Dropdown Menu popup.
 * - On mobile phone screens (< 640px): Renders the Full-Screen Mobile Drawer with search card & shortcuts.
 */
const MoreToolsDropdown = ({
  isDark,
  moreMenuOpen,
  setMoreMenuOpen,
  moreMenuRef,
  moreMenuItems,
  changeLng,
  handleSettings,
  handelLogout,
}) => {
  const {
    user,
    isSearchOpen,
    setIsSearchOpen,
    profile,
    closeMenu,
    handleSearchResultClick,
    fullName,
    role,
    initial,
    currency,
    currencyIconUrl,
    hasWallet,
    quickNavItems,
  } = useMoreToolsDropdown({ isDark, moreMenuOpen, setMoreMenuOpen });

  return (
    <div className="relative lg:hidden" ref={moreMenuRef}>
      <MoreToolsTriggerButton
        isDark={isDark}
        onToggle={() => setMoreMenuOpen(!moreMenuOpen)}
      />

      {/* 1. TABLET / DESKTOP DROPDOWN POPUP (640px - 1023px) */}
      {moreMenuOpen && !isSearchOpen && (
        <MoreToolsPopupMenu moreMenuItems={moreMenuItems} />
      )}

      {/* 2. PHONE FULL-SCREEN DRAWER (< 640px) */}
      {moreMenuOpen && !isSearchOpen && typeof document !== "undefined" && (
        <MoreToolsMobileDrawer
          isDark={isDark}
          user={user}
          fullName={fullName}
          role={role}
          initial={initial}
          onClose={closeMenu}
          onLogout={
            handelLogout
              ? () => {
                  closeMenu();
                  handelLogout();
                }
              : undefined
          }
          hasWallet={hasWallet}
          walletBalance={profile?.wallet?.balance}
          currency={currency}
          currencyIconUrl={currencyIconUrl}
          quickNavItems={quickNavItems}
          onSettings={() => {
            closeMenu();
            handleSettings?.();
          }}
          onChangeLanguage={() => {
            closeMenu();
            changeLng?.();
          }}
        />
      )}

      {/* DEDICATED FULL-SCREEN SEARCH MODAL (Triggered from mobile drawer) */}
      <MobileSearchModal
        isDark={isDark}
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
        onSelectResult={handleSearchResultClick}
      />
    </div>
  );
};

export default MoreToolsDropdown;
